import Text from '@deprecated-ui/common/Text';
import Iconmoon, { IconWrapper } from '@deprecated-ui/common/Iconmoon';
import color from '@deprecated-ui/_style/color';
import React from 'react';
import { PinnedPollingLabelContainer } from './styled';

interface PollingPinnedLabelProps {
  children: React.ReactNode;
  onClick: () => any;
  isActive: boolean;
  [key: string]: any;
}

function PollingPinnedLabel({ children, onClick, isActive, ...props }: PollingPinnedLabelProps) {
  return (
    <PinnedPollingLabelContainer onClick={onClick} {...props}>
      <IconWrapper size="20px">
        <Iconmoon
          className={`icon-toolbar_pinned${isActive ? '-fill' : ''}`}
          size="20px"
        />
      </IconWrapper>
      <Text size="14px" color={color.midgray}>
        {children}
      </Text>
    </PinnedPollingLabelContainer>
  );
}

export default PollingPinnedLabel;
